import React, { useCallback } from 'react';
import * as R from 'ramda';
import { getGanttConfig } from '@constants/config';
import { DropdownFilter, useDropdownFilter } from './base-dropdown-filter';

const LocationFilter = () => {
  const getItems = useCallback(
    () => R.values(getGanttConfig().locationTypes).map(locationType => ({
      id: locationType.id,
      name: locationType.label
    })),
    []
  );

  const {
    items,
    filterChange,
    filterClose,
    getChecked,
    selected
  } = useDropdownFilter({
    name: 'locationType',
    getItems
  });

  const renderValue = useCallback(
    () => R.values(getGanttConfig().locationTypes).find(locationType => locationType.id === selected).selectedLabel,
    [selected]
  );

  return (
    <DropdownFilter
      items={items}
      multiple={false}
      filterChange={filterChange}
      filterClose={filterClose}
      renderValue={renderValue}
      getChecked={getChecked}
      selected={selected}
    />
  );
};

export default LocationFilter;
